import { invalidateCache } from '../utils/invalidateCache'

const cacheInvalidateUpdaters = {}
const cacheInvalidateMutationsList = [
    'deactivateAccount',
    'activateAccount',
    'revokeUserInvitation',
]

cacheInvalidateMutationsList.forEach((mutation) => {
    cacheInvalidateUpdaters[mutation] = (result, args, cache) => {
        invalidateCache(cache, 'users')
        invalidateCache(cache, 'group')
    }
})

const countUsersUpdaters = {
    ...cacheInvalidateUpdaters,
}

export { countUsersUpdaters }
